export const DEFAULT_ATTENDEE_CONSULTATION_PAGE_SIZE = 100;

const positiveInteger = (value, fallback) => {
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : fallback;
};

const sortAttendeeRowsAlphabetically = (rows = []) => {
  const hasAttendeeNames = rows.some((row) => String(row?.fullName || '').trim());
  if (!hasAttendeeNames) return [...rows];

  return [...rows].sort((left, right) => {
    const leftName = String(left?.fullName || '').trim();
    const rightName = String(right?.fullName || '').trim();
    if (!leftName && rightName) return 1;
    if (leftName && !rightName) return -1;
    const byName = leftName.localeCompare(rightName, 'pt-BR', {
      sensitivity: 'base',
      numeric: true,
    });
    if (byName !== 0) return byName;
    return Number(left?.id || 0) - Number(right?.id || 0);
  });
};

export const paginateAttendeeRows = (
  rows = [],
  requestedPage = 1,
  requestedPageSize = DEFAULT_ATTENDEE_CONSULTATION_PAGE_SIZE,
) => {
  const safeRows = sortAttendeeRowsAlphabetically(Array.isArray(rows) ? rows : []);
  const showAll = Number(requestedPageSize) === 0;
  if (showAll) {
    return {
      rows: safeRows,
      page: 1,
      pageSize: 0,
      totalPages: 1,
      start: safeRows.length ? 1 : 0,
      end: safeRows.length,
      total: safeRows.length,
    };
  }

  const pageSize = positiveInteger(requestedPageSize, 50);
  const totalPages = Math.max(1, Math.ceil(safeRows.length / pageSize));
  const page = Math.min(positiveInteger(requestedPage, 1), totalPages);
  const startIndex = (page - 1) * pageSize;
  const endIndex = Math.min(startIndex + pageSize, safeRows.length);

  return {
    rows: safeRows.slice(startIndex, endIndex),
    page,
    pageSize,
    totalPages,
    start: safeRows.length ? startIndex + 1 : 0,
    end: endIndex,
    total: safeRows.length,
  };
};
